import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import BreadcrumbLayout from 'layouts/BreadcrumbLayout';
import RouteShipmentForm from './RouteShipmentComponents/RouteShipmentForm';

import {
  useGetRouteShipmentDetailQuery,
  useUpdateRouteShipmentMutation,
} from 'store/services/routeShipmentApi';
import { useAppMeta } from 'hooks';

const RouteShipmentEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: 'Route Shipments', path: '/app/crm/route-shipment/list' },
    { title: 'Edit Route Shipment' },
  ];

  // RTK Query
  const {
    data: routeShipmentDetail,
    isLoading: loadingRouteShipment,
    error,
  } = useGetRouteShipmentDetailQuery(id);

  const [updateRouteShipment, { isLoading: updatingRouteShipment }] =
    useUpdateRouteShipmentMutation();

  // Handle update
  const handleUpdateRouteShipment = async (data) => {
    const _payload = { ...data };
    delete _payload.disclaimers;

    try {
      await updateRouteShipment({ _id: id, ..._payload }).unwrap();
      toast.success('Route Shipment successfully updated!');
      navigate(`/app/crm/route-shipment/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? 'Could not update Route Shipment!'
      );
    }
  };

  useAppMeta('Edit Route Shipment');

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingRouteShipment || updatingRouteShipment}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <RouteShipmentForm
          isBusy={loadingRouteShipment || updatingRouteShipment}
          routeShipmentDetail={routeShipmentDetail}
          onSubmit={handleUpdateRouteShipment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default RouteShipmentEditScreen;